import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { CallbackComponent } from './callback.component';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [CallbackComponent],
})
export class CallbackModule {}
